import React from 'react';

const StatusBadge = ({ status }) => {
  if (!status) return null;

  const getStatusConfig = (status) => {
    switch (status.toLowerCase()) {
      case 'success':
        return {
          className: 'status-badge success',
          icon: '✓',
          text: 'SUCCESS'
        };
      case 'error':
      case 'compile_error':
      case 'runtime_error':
        return {
          className: 'status-badge error',
          icon: '✗',
          text: status.toUpperCase().replace('_', ' ')
        };
      case 'timeout':
        return {
          className: 'status-badge timeout',
          icon: '⏱',
          text: 'TIMEOUT'
        };
      default:
        return {
          className: 'status-badge unknown',
          icon: '?',
          text: status.toUpperCase()
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <span className={config.className}>
      <span className="status-icon">{config.icon}</span>
      <span className="status-text">{config.text}</span>
    </span>
  );
};

export default StatusBadge;
